var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgInbox = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.437 10.476a2.25 2.25 0 0 1 2.069-1.364h10.743a2.25 2.25 0 0 1 2.012 1.244l2.407 4.813H20.7c-.58 0-1.009.415-1.136.887-.348 1.29-1.722 2.352-3.48 2.352-1.757 0-3.13-1.062-3.478-2.352-.128-.472-.557-.887-1.136-.887H6.426zm-3.893 5.538a.75.75 0 0 1 .055-.39l2.46-5.74a3.75 3.75 0 0 1 3.446-2.272H21.25a3.75 3.75 0 0 1 3.354 2.073l2.95 5.9a.75.75 0 0 1 .073.429q.006.052.006.105v5.518a4.75 4.75 0 0 1-4.75 4.75H9.288a4.75 4.75 0 0 1-4.75-4.75v-5.518q0-.052.006-.105m1.494 5.623v-4.968h5.186c.636 1.924 2.62 3.24 4.86 3.24 2.242 0 4.226-1.316 4.861-3.24h5.187v4.968a3.25 3.25 0 0 1-3.25 3.25H9.288a3.25 3.25 0 0 1-3.25-3.25",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInbox);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };